// DO NOT MODIFY - generated by `rake intl:compile_page[design_system]` from
// config/locales/design_system/*.yml. Edit those files and re-run instead.
import I18n from 'i18n-js';

I18n.translations['en'] = I18n.extend((I18n.translations['en'] || {}), {"design_system":{"modal":{"close":"Close","back":"Back"},"truncate":{"read_more":"Read more"},"skeleton":{"loading":"Loading..."},"typeahead":{"no_results":"No results found","searching":"Searching...","create_new":"Create new:"}}});
// 7e0b6b5952c707541c9b20276fa40985
